import KeyInputMoney from './input-money'

export { formatMoney } from './tools'
export default KeyInputMoney



// WEBPACK FOOTER //
// ./src/public/components/kye-input-money/index.js